import React, { useState, useEffect } from 'react'

// TODO: move to types.ts, convert values to proper interfaces
export interface UserRowInteractionsType {
  setSelected: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
  selectedRows: Record<string, boolean>
  sortedUsers: { id: string }[]
}

/**
 * Handle multiple user rows interaction when shift key is pressed
 */
export function useUserRowInteractions({
  setSelected,
  selectedRows,
  sortedUsers,
}: UserRowInteractionsType) {
  const [shiftKey, setShiftKey] = useState<boolean>(false)

  useEffect(() => {
    window.addEventListener('keydown', handleUpdateShiftKey)
    window.addEventListener('keyup', handleUpdateShiftKey)

    return () => {
      window.removeEventListener('keydown', handleUpdateShiftKey)
      window.removeEventListener('keyup', handleUpdateShiftKey)
    }

    function handleUpdateShiftKey(e: KeyboardEvent) {
      setShiftKey(e.shiftKey)
    }
  }, [])

  /**
   * Handle multiple rows selection when shift key is pressed
   * @param {number} lastSelectedIndex
   * @param {number} rowIndex Row index.
   * @returns
   */
  function handleSelectMultipleRows(lastSelectedIndex: number, rowIndex: number) {
    const max = Math.max(rowIndex, lastSelectedIndex)
    const min = Math.min(rowIndex, lastSelectedIndex)

    const rowsToSelect = sortedUsers.slice(min, max + 1).reduce(
      (memo, user) => ({
        ...memo,
        [user.id]: true,
      }),
      {},
    )
    setSelected({ ...selectedRows, ...rowsToSelect })
  }

  return {
    handleSelectMultipleRows,
    shiftKey,
  }
}
